<div class="page-head">
  <div class="min-w-0">
    <p class="eyebrow">ภาพรวมฝ่ายขาย</p>
    <h1>Dashboard ฝ่ายขาย</h1>
    <p>สวัสดี, {{ auth.user()?.firstName }} · ติดตามยอดขาย การรับชำระ และ Booking</p>
  </div>
  <app-refresh-button
    label="รีเฟรช Dashboard ฝ่ายขาย"
    [loading]="isLoading()"
    (refresh)="loadDashboard()"
  />
</div>

@if (dashboard()) {
<div class="mb-4 flex justify-end">
  <span class="rounded-full bg-slate-100 px-2.5 py-1 text-[11px] font-semibold text-slate-500">
    {{ monthLabel() }}
  </span>
</div>

<section
  [class]="
    canViewApprovalTasks()
      ? 'grid gap-4 sm:grid-cols-2 xl:grid-cols-4'
      : 'grid gap-4 sm:grid-cols-2 xl:grid-cols-3'
  "
  aria-label="สรุปยอดขาย"
>
  <article class="card p-5">
    <div class="flex items-start justify-between gap-3">
      <div>
        <p class="m-0 text-xs font-medium text-slate-500">ยอดขายเดือนนี้</p>
        <p class="mt-2 mb-0 text-2xl font-bold text-slate-800 tabular-nums">{{ summary()?.netSales | number: '1.2-2' }}</p>
        <p class="mt-1 mb-0 text-xs text-slate-500">บาท </p>
      </div>
      <span class="stat-icon green shrink-0">
        <lucide-icon name="CircleDollarSign" [size]="20" />
      </span>
    </div>
  </article>
  <article class="card p-5">
    <div class="flex items-start justify-between gap-3">
      <div>
        <p class="m-0 text-xs font-medium text-slate-500">Booking ใหม่</p>
        <p class="mt-2 mb-0 text-2xl font-bold text-slate-800 tabular-nums">{{ summary()?.newBookingCount | number: '1.0-0' }}</p>
        <p class="mt-1 mb-0 text-xs text-slate-500">รายการในเดือนนี้</p>
      </div>
      <span class="stat-icon blue shrink-0">
        <lucide-icon name="BookOpenCheck" [size]="20" />
      </span>
    </div>
  </article>
  <article class="card p-5">
    <div class="flex items-start justify-between gap-3">
      <div>
        <p class="m-0 text-xs font-medium text-slate-500">ยอดรอเก็บจากลูกค้า</p>
        <p class="mt-2 mb-0 text-2xl font-bold text-slate-800 tabular-nums">{{ summary()?.outstandingAmount | number: '1.2-2' }}</p>
        <p class="mt-1 mb-0 text-xs text-slate-500">บาท · {{ summary()?.outstandingBookingCount }} Booking ในเดือนนี้</p>
      </div>
      <span class="stat-icon amber shrink-0">
        <lucide-icon name="Clock3" [size]="20" />
      </span>
    </div>
  </article>
  @if (canViewApprovalTasks()) {
    <article class="card p-5">
      <div class="flex items-start justify-between gap-3">
        <div>
          <p class="m-0 text-xs font-medium text-slate-500">งานรออนุมัติ</p>
          <p class="mt-2 mb-0 text-2xl font-bold text-slate-800 tabular-nums">{{ summary()?.pendingApprovalCount | number: '1.0-0' }}</p>
          <p class="mt-1 mb-0 text-xs text-slate-500">ใบเบิก คอมมิชชั่น ปรับวงเงิน</p>
        </div>
        <span class="stat-icon purple shrink-0">
          <lucide-icon name="ClipboardCheck" [size]="20" />
        </span>
      </div>
    </article>
  }
</section>

<div class="mt-5">
  <section class="card min-w-0 p-5 sm:p-6" aria-labelledby="collection-title">
    <div class="flex flex-wrap items-start justify-between gap-3">
      <div>
        <h2 id="collection-title" class="m-0 text-base font-bold text-slate-800">
          ภาพรวมการรับชำระ
        </h2>
        <p class="mt-1 mb-0 text-xs text-slate-500">ยอด Booking ใน {{ monthLabel() }}</p>
      </div>
    </div>

    <div class="mt-6 grid gap-4 sm:grid-cols-3">
      <div>
        <p class="m-0 text-xs text-slate-500">ยอดขาย</p>
        <strong class="mt-1 block text-lg text-slate-800 tabular-nums">
          {{ salesTotal() | number: '1.2-2' }} บาท
        </strong>
      </div>
      <div>
        <p class="m-0 text-xs text-slate-500">รับชำระแล้ว</p>
        <strong class="mt-1 block text-lg text-emerald-700 tabular-nums">
          {{ collectedTotal() | number: '1.2-2' }} บาท
        </strong>
      </div>
      <div>
        <p class="m-0 text-xs text-slate-500">รอเก็บจากลูกค้า</p>
        <strong class="mt-1 block text-lg text-amber-700 tabular-nums">
          {{ outstandingTotal() | number: '1.2-2' }} บาท
        </strong>
      </div>
    </div>

    <div class="mt-5 h-2.5 overflow-hidden rounded-full bg-slate-100" aria-hidden="true">
      <div
        class="h-full rounded-full bg-emerald-500 transition-all"
        [style.width.%]="collectionPercent()"
      ></div>
    </div>
  </section>

</div>



<section class="mt-5 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
  <div class="flex items-center justify-between gap-3 border-b border-slate-200 px-5 py-4 sm:px-6">
    <div>
      <h2 class="m-0 text-base font-bold text-slate-800">Booking ล่าสุด</h2>
      <p class="mt-1 mb-0 text-xs text-slate-500">รายการจอยทัวร์และเหมากรุ๊ปล่าสุด 5 รายการ</p>
    </div>
    <a
      routerLink="/bookings"
      class="text-xs font-semibold text-sky-700 no-underline hover:underline"
      >ดูทั้งหมด</a
    >
  </div>
  <div class="overflow-x-auto">
    <table class="w-full min-w-[760px] border-collapse text-left">
      <thead class="bg-slate-50 text-xs text-slate-500">
        <tr>
          <th class="px-5 py-3 font-semibold">Booking</th>
          <th class="px-5 py-3 font-semibold whitespace-nowrap">ประเภทการจอง</th>
          <th class="px-5 py-3 font-semibold">ลูกค้าและทัวร์</th>
          <th class="px-5 py-3 text-right font-semibold">ยอดเรียกเก็บ</th>
          <th class="px-5 py-3 font-semibold">สถานะ</th>
          <th class="px-5 py-3 text-right font-semibold">ดูรายการ</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-slate-100">
        @for (booking of recentBookings(); track booking.id) {
          <tr class="hover:bg-slate-50/70">
            <td class="px-5 py-3.5 text-sm font-semibold whitespace-nowrap text-sky-700">
              {{ booking.code }}
            </td>
            <td class="px-5 py-3.5 text-sm whitespace-nowrap text-slate-700">
              {{ booking.bookingType === 'GROUP_TOUR' ? 'เหมากรุ๊ป' : 'จอยทัวร์' }}
            </td>
            <td class="px-5 py-3.5">
              <p class="m-0 text-sm font-medium text-slate-800">{{ booking.customerName }}</p>
              <p class="mt-1 mb-0 text-xs text-slate-500">{{ booking.tripName }}</p>
            </td>
            <td
              class="px-5 py-3.5 text-right text-sm font-semibold whitespace-nowrap text-slate-800 tabular-nums"
            >
              {{ booking.totalAmount | number: '1.2-2' }} บาท
            </td>
            <td class="px-5 py-3.5"><app-status-badge [status]="booking.status" /></td>
            <td class="px-5 py-3.5 text-right">
              <a
                [routerLink]="['/bookings', booking.id]"
                [queryParams]="{ from: booking.bookingType === 'GROUP_TOUR' ? 'group-bookings' : 'bookings' }"
                class="inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 text-slate-500 transition hover:bg-slate-50 hover:text-slate-700"
                title="ดูรายละเอียด"
                ><lucide-icon name="Eye" [size]="15"
              /></a>
            </td>
          </tr>
        } @empty {
          <tr><td colspan="6" class="px-5 py-8 text-center text-sm text-slate-500">ยังไม่มีรายการ Booking</td></tr>
        }
      </tbody>
    </table>
  </div>
</section>
}
